export const getTargetDate = () => {
    const target = new Date(2025, 11, 2, 23, 59, 0);
    return target;
};
